import "./Loader.scss";

export const Loader = () => {
    return (
        <div className="loader-cont">
            <div className="spinner icon-spinner" aria-hidden="true"></div>
        </div>
    );
};
